interface FilmCardProps {
  title: string;
  original?: string;
  poster: string;
  rating?: string;
  meta?: string;
  duration?: string;
  summary?: string;
  tags?: string[];
  type?: string;
}

export default function FilmCard({
  title,
  original,
  poster,
  rating,
  meta,
  duration,
  summary,
  tags,
  type,
}: FilmCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200/80 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={poster}
          alt={`${title} 海报`}
          title={`${title} 影视片单海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {rating ? (
          <span className="absolute top-2 right-2 inline-flex items-center gap-1 h-7 px-2 rounded-md bg-background-50/95 text-xs font-semibold text-foreground-950 font-label">
            <i className="ri-star-fill text-primary-500 text-xs" />
            {rating}
          </span>
        ) : null}
        {type ? (
          <span className="absolute bottom-2 left-2 inline-flex items-center h-6 px-2 rounded-md bg-background-950/70 text-[11px] font-medium text-background-50 font-label">
            {type}
          </span>
        ) : null}
      </div>
      <div className="flex flex-col flex-1 p-3 md:p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 truncate">
          {title}
        </h3>
        {original ? (
          <p className="mt-0.5 text-xs text-foreground-400 font-label truncate">
            {original}
          </p>
        ) : null}
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500 font-label">
          {meta ? <span>{meta}</span> : null}
          {meta && duration ? <span className="text-background-400">·</span> : null}
          {duration ? <span>{duration}</span> : null}
        </div>
        {summary ? (
          <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-3">
            {summary}
          </p>
        ) : null}
        {tags && tags.length > 0 ? (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center h-6 px-2 rounded-md bg-secondary-50 text-[11px] text-secondary-800 font-label border border-secondary-200/70"
              >
                {tag}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </article>
  );
}